import apiService from '@/api/apiService';

export const getConsultationLevels = () =>
    apiService.GET('/api/admin/consultation-levels');

export const getConsultationLevel = (id) =>
    apiService.GET(`/api/admin/consultation-levels/${id}`);

export const createConsultationLevel = (data) =>
    apiService.POST('/api/admin/consultation-levels', data);

export const updateConsultationLevel = (id, data) =>
    apiService.PUT(`/api/admin/consultation-levels/${id}`, data);

export const getBookingServiceType = (code = 'consultation') =>
    apiService.GET(`/api/admin/booking-service-types/${code}`);

export const updateBookingServiceType = (code, data) =>
    apiService.PUT(`/api/admin/booking-service-types/${code}`, data);

export const listBookingServiceTypes = () =>
    apiService.GET('/api/admin/booking-service-types');

export const createBookingServiceType = (data) =>
    apiService.POST('/api/admin/booking-service-types', data);

export const getBookingScheduleDates = (code, month) =>
    apiService.GET(`/api/admin/booking-service-types/${code}/schedule-dates`, { month });

export const updateBookingScheduleDates = (code, data) =>
    apiService.PUT(`/api/admin/booking-service-types/${code}/schedule-dates`, data);

export const getBookingAdminGrants = (code) =>
    apiService.GET(`/api/admin/booking-service-types/${code}/admin-grants`);

export const updateBookingAdminGrants = (code, data) =>
    apiService.PUT(`/api/admin/booking-service-types/${code}/admin-grants`, data);

export const getConsultationTicketSettings = () =>
    apiService.GET('/api/admin/consultation-ticket-settings');

export const updateConsultationTicketSettings = (data) =>
    apiService.PUT('/api/admin/consultation-ticket-settings', data);

export const getConsultants = () => apiService.GET('/api/admin/consultants');

export const getPendingConsultants = () =>
    apiService.GET('/api/admin/consultants/pending');

export const updateConsultant = (id, data) =>
    apiService.PUT(`/api/admin/consultants/${id}`, data);

export const getConsultations = (params) =>
    apiService.GET('/api/admin/consultations', params);

export const getConsultationBookingAvailability = (params) =>
    apiService.GET('/api/admin/consultations/booking-availability', params);

export const getConsultationVersionEligibility = (params) =>
    apiService.GET('/api/admin/consultations/version-eligibility', params);

export const createConsultation = (data) =>
    apiService.POST('/api/admin/consultations', data);

export const updateConsultation = (id, data) =>
    apiService.PUT(`/api/admin/consultations/${id}`, data);

export const transferConsultation = (id, data) =>
    apiService.POST(`/api/admin/consultations/${id}/transfer`, data);

export const getTransferRequests = () =>
    apiService.GET('/api/admin/consultation-transfer-requests');

export const acceptTransferRequest = (id) =>
    apiService.POST(`/api/admin/consultation-transfer-requests/${id}/accept`);

export const rejectTransferRequest = (id) =>
    apiService.POST(`/api/admin/consultation-transfer-requests/${id}/reject`);

export const getConsultantSchedule = (coreMemberId, params) =>
    apiService.GET(`/api/admin/consultants/${coreMemberId}/schedule`, params);

export const getConsultantScheduleSlots = (coreMemberId, params) =>
    apiService.GET(`/api/admin/consultants/${coreMemberId}/schedule/slots`, params);

export const getConsultantScheduleRules = (coreMemberId, params) =>
    apiService.GET(`/api/admin/consultants/${coreMemberId}/schedule/rules`, params);

export const updateConsultantScheduleRules = (coreMemberId, data) =>
    apiService.PUT(`/api/admin/consultants/${coreMemberId}/schedule/rules`, data);

export const getConsultantsScheduleOverview = (params) =>
    apiService.GET('/api/admin/consultants/schedule-overview', params);

export const getConsultantsCompliance = (params) =>
    apiService.GET('/api/admin/consultants/compliance', params);
